<template lang="pug">
    #app(v-loading="! loaded" :class="{ locked: maintenance }")
        transition(name="fade" mode="out-in")
            .maintenance(v-if="maintenance")
                .stripes
                .content
                    .code(v-loading="checkingHealth") 503
                    .message(v-if="maintenance === true")
                        p {{ $t('Under construction') }}
                        small
                            a(href="#" @click.prevent="checkHealth")
                                | {{ $t("check if the maintenance is done") }}
                    .message(v-else)
                        p {{ $t(maintenance) }}
                        small
                            a(href="#" @click.prevent="checkHealth")
                                | {{ $t("check if the maintenance is done") }}
        .public(v-if="public")
            transition(name="slide-fade" mode="out-in")
                router-view.Main__view
        router-view(v-else-if="scan")
        Auth(v-else-if="routeResolved")
            transition(:name="animation" mode="out-in")
                router-view.Main__view
        portal-target(name="app" slim)
</template>

<i18n>
{
    "de": {
        "Under construction": "Im Wartungsmodus",
        "check if the maintenance is done": "prüfen, ob die Wartungsarbeiten abgeschlossen sind"
    }
}
</i18n>

<script>

import _ from 'lodash'

import { useAuthStore, useSetupStore } from '@/stores'

import Auth from '@/components/Auth'

export default {
    name: 'app',
    data() {
        return {
            checkingHealth: false,
        }
    },
    components: {
        Auth,
    },
    watch: {
        $route(route) {
            const context = _.get(route, 'meta.context');
            setTimeout(() => {
                // this.context = context;
                document.body.className = context;
            }, 300)
        }
    },
    computed: {
        // context() {
        //     return _.get(this.$route, 'meta.context');
        // },
        // component() {
        //     let component = 'Auth'
        //     if (_.get(this.$route, 'meta.public')) component = 'div'
        //     return component
        // },
        public() {
            return _.get(this.$route, 'meta.public')
        },
        scan() {
            return _.get(this.$route, 'meta.scan')
        },
        user() {
            return useAuthStore().user
        },
        loaded() {
            return useSetupStore().loaded
        },
        animation() {
            return useSetupStore().animation
        },
        maintenance() {
            return useSetupStore().maintenance
        },
        routeResolved() {
            return !!this.$route.name
        }
    },
    methods: {
        checkHealth() {
            this.checkingHealth = true
            useSetupStore().checkHealth()
                .finally(() => {
                    this.checkingHealth = false
                })
        }
    },
    mounted() {
        const context = _.get(this.$route, 'meta.context');
        document.body.className = context;
    }
}
</script>

<style lang="sass">
    @import '~@/assets/sass/globals'
    .Main
        &__wrapper
            overflow: auto
        &__view_table
            min-width: 820px
    .slide-fade-enter-active
        transition: all .35s ease
    .slide-fade-leave-active
        transition: all .35s cubic-bezier(1.0, 0.5, 0.8, 1.0)
    .slide-fade-enter, .slide-fade-leave-to
        transform: translateY(8px)
        opacity: 0
    .public
        display: flex
        min-height: 100vh
        justify-content: center
        align-items: center
</style>
